import React, { useImperativeHandle, useRef, useEffect, useState } from "react";
import { gsap } from "gsap";

import CompStatusSlider from "../../components/Elements/Complications/CompStatusSlider";
import CompLeaderboard from "../../components/Elements/Complications/CompLeaderboard";
import CompSpacer from "../../components/Elements/Complications/CompSpacer";
import CompPlayback from "../../components/Elements/Complications/CompPlayback";
import CompStatusLed from "../../components/Elements/Complications/CompStatusLed";
import CompVoiceRecording from "../../components/Elements/Complications/CompVoiceRecording";
import CompProgressTimeline from "../../components/Elements/Complications/CompProgressTimeline";

import CompCountdown from "../../components/Elements/Complications/CompCountdown";
import CompHeaderImage from "../../components/Elements/Complications/CompHeaderImage";

import cases from "../cases/cases.json";

const componentName = "MotionCapture"; //name must match Javascript filename and component name in. ../cases/cases.json/index.js

const shorthand = cases.find((x) => x.component == componentName).shorthand;

//DATA
//prettier-ignore
const emotions_data=[{"Time":0,"Neutral":0.57369,"Amazement":0,"Anger":0.04258,"Cheekines":0,"Disgust":0.04502,"Fear":0.0454,"Grief":0,"Joy":0.22181,"Out of breath":0,"Pain":0,"Sad":0.07145},{"Time":60,"Neutral":0.52481,"Amazement":0,"Anger":0.2993,"Cheekines":0,"Disgust":0.00525,"Fear":0.0044,"Grief":0,"Joy":0.16049,"Out of breath":0,"Pain":0,"Sad":0.00575},{"Time":120,"Neutral":0.56849,"Amazement":0,"Anger":0.24606,"Cheekines":0,"Disgust":0.03072,"Fear":0.00711,"Grief":0,"Joy":0.16779,"Out of breath":0,"Pain":0,"Sad":0.00983},{"Time":180,"Neutral":0.52456,"Amazement":0,"Anger":0.3001,"Cheekines":0,"Disgust":0.00549,"Fear":0.00439,"Grief":0,"Joy":0.15966,"Out of breath":0,"Pain":0,"Sad":0.00581},{"Time":240,"Neutral":0.5245,"Amazement":0,"Anger":0.02237,"Cheekines":0,"Disgust":0.00582,"Fear":0.0046,"Grief":0,"Joy":0.43683,"Out of breath":0,"Pain":0,"Sad":0.00587},{"Time":300,"Neutral":0.52544,"Amazement":0,"Anger":0.00448,"Cheekines":0,"Disgust":0.00393,"Fear":0.21628,"Grief":0,"Joy":0.2394,"Out of breath":0,"Pain":0,"Sad":0.01047},{"Time":360,"Neutral":0.52625,"Amazement":0,"Anger":0.00484,"Cheekines":0,"Disgust":0.00423,"Fear":0.2172,"Grief":0,"Joy":0.195,"Out of breath":0,"Pain":0,"Sad":0.05248},{"Time":420,"Neutral":0.52459,"Amazement":0,"Anger":0.00393,"Cheekines":0,"Disgust":0.00376,"Fear":0.00562,"Grief":0,"Joy":0.45425,"Out of breath":0,"Pain":0,"Sad":0.00785},{"Time":480,"Neutral":0.57488,"Amazement":0,"Anger":0.04852,"Cheekines":0,"Disgust":0.04232,"Fear":0.04368,"Grief":0,"Joy":0.23075,"Out of breath":0,"Pain":0,"Sad":0.05985},{"Time":540,"Neutral":0.53536,"Amazement":0,"Anger":0.00614,"Cheekines":0,"Disgust":0.00681,"Fear":0.00987,"Grief":0,"Joy":0.43439,"Out of breath":0,"Pain":0,"Sad":0.00743},{"Time":600,"Neutral":0.57826,"Amazement":0,"Anger":0.01167,"Cheekines":0,"Disgust":0.04485,"Fear":0.01755,"Grief":0,"Joy":0.32799,"Out of breath":0,"Pain":0,"Sad":0.01566},{"Time":660,"Neutral":0.81747,"Amazement":0,"Anger":0.00439,"Cheekines":0,"Disgust":0.00405,"Fear":0.00527,"Grief":0,"Joy":0.16042,"Out of breath":0,"Pain":0,"Sad":0.00841}];

//prettier-ignore
const connection_data=[{"Time":0,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":60,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":120,"Suit 'Actor 1'":0.9,"Suit 'Actor 2'":0.7},{"Time":180,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":240,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":300,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":360,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":420,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":480,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":540,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":600,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":660,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":720,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":780,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":840,"Suit 'Actor 1'":0.9,"Suit 'Actor 2'":0.7},{"Time":900,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.7},{"Time":960,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":1020,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":1080,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":1140,"Suit 'Actor 1'":0.8,"Suit 'Actor 2'":0.8},{"Time":1200,"Suit 'Actor 1'":0.9,"Suit 'Actor 2'":0.7}];
export default React.forwardRef((props, ref) => {
	const initialLoaded = useRef(false);
	const curVideoRef = useRef(null);
	const curTime = useRef(null);
	const [isActive, setIsActive] = useState(false);
	const [duration, setDuration] = useState(null);

	const compRef00 = useRef(null);
	const compRef01 = useRef(null);
	const compRef02 = useRef(null);
	const curActiveContainer = useRef(null);

	const restartEvent = useRef(null);
	const lastLoopVideoLoop = useRef(Date.now());
	const lastCustomLoop = useRef(null);

	const timeupdate = () => {
		if (!curVideoRef.current) return;

		const curTimeVideo = curVideoRef.current.currentTime;
		const curDurationVideo = curVideoRef.current.duration;

		if (!curDurationVideo) return;

		let shouldRestart = false;

		if (curTime.current > curTimeVideo) {
			lastLoopVideoLoop.current = Date.now();
			if (!props.solution?.["custom-loop"]) {
				shouldRestart = true;
			}
		}

		//console.log(props.solution);
		if (props.solution?.["custom-loop"]) {
			const customLoopPoint =
				(props.solution?.["custom-loop"] - 1) /
				props.solution?.["framerate"];

			if (curTimeVideo > customLoopPoint) {
				if (
					lastCustomLoop.current &&
					lastCustomLoop.current > lastLoopVideoLoop.current
				) {
					// console.log("quit");
					return;
				}

				lastCustomLoop.current = Date.now();

				shouldRestart = true;
				//console.log(customLoopPoint);
				// console.log(curTimeVideo * 30);
				// console.log(curDurationVideo * 30);
				// console.log("dispatchEventlistener");
			}
		}

		if (shouldRestart) {
			const restartEvent = new Event("onRestart");
			curActiveContainer.current?.dispatchEvent?.(restartEvent);
		}

		curTime.current = curTimeVideo;

		if (duration !== curDurationVideo) {
			setDuration(curDurationVideo);
		}
	};

	useEffect(() => {
		const curDurationVideo = curVideoRef.current?.duration || 0;
		setDuration(curDurationVideo);
	}, [props.srcVidMain]);

	useEffect(() => {
		if (!initialLoaded.current) {
			initialLoaded.current = true;
		}
	}, []);

	useEffect(() => {
		if (isActive !== props.isActiveSlide) {
			setIsActive(props.isActiveSlide);
		}
	}, [props.isActiveSlide]);

	useEffect(() => {
		if (curVideoRef.current !== props.curVideo.current || isActive) {
			curVideoRef.current = props.curVideo.current;
			if (curVideoRef.current && isActive) {
				//add eventlister
				gsap.ticker.add(timeupdate);
				curVideoRef.current.addEventListener(
					"durationchange",
					timeupdate,
				);
			}
		}
		return () => {
			if (curVideoRef.current) {
				gsap.ticker.remove(timeupdate);
				//remove eventlistener
				curVideoRef.current.removeEventListener(
					"durationchange",
					timeupdate,
				);
			}
		};
	}, [props.curVideo, isActive]);

	useImperativeHandle(
		ref,
		() => {
			return {
				switchVideo(nextVideo, instant = true) {
					if (
						!compRef00.current ||
						!compRef01.current ||
						!compRef02.current
					)
						return;

					switch (nextVideo) {
						case 0:
							curActiveContainer.current = compRef00.current;
							break;
						case 1:
							curActiveContainer.current = compRef01.current;
							break;
						case 2:
							curActiveContainer.current = compRef02.current;
							break;
						default:
							curActiveContainer.current = null;
							break;
					}
					if (curActiveContainer.current)
						gsap.set(curActiveContainer.current, { autoAlpha: 1 });

					[
						compRef00.current,
						compRef01.current,
						compRef02.current,
					].forEach((x) => {
						if (x == curActiveContainer.current) return;
						gsap.set(x, { autoAlpha: 0 });
						const seekEvent = new CustomEvent("onPause");
						x?.dispatchEvent?.(seekEvent);
					});

					const curTimeVideo = curVideoRef.current.currentTime;
					const curDurationVideo = curVideoRef.current.duration;

					let customLoopPoint = 0;
					if (
						props.solution?.["custom-loop"] &&
						props.solution?.["framerate"]
					) {
						customLoopPoint =
							props.solution?.["custom-loop"] /
							props.solution?.["framerate"];
					}

					const seekEvent = new CustomEvent("onSeek", {
						detail: {
							playSecond:
								curTimeVideo +
								(curDurationVideo - customLoopPoint),
						},
					});
					curActiveContainer.current?.dispatchEvent?.(seekEvent);
				},
			};
		},
		[],
	);

	const calcOffset = (relOffset) => {
		return relOffset * props.curScale;
	};

	return !isActive ? null : (
		<>
			{/*	{true ? (
						<>*/}
			{props?.isSmallScreen ? (
				<>
					<div
						className="complications-wrapper"
						style={{ visibility: "hidden", opacity: 0 }}
						id="comp-vid-0"
						ref={compRef00}
					>
						<CompSpacer />
						<CompProgressTimeline
							firstRowOneTxt="Prototype"
							firstRowTwoTxt="Brand Integration"
							firstRowThreeTxt="Level Design"
							firstRowFourTxt="Balancing"
							firstRowFiveTxt="Publish"
							secondRowOneTxt=""
							secondRowTwoTxt="Sprint 2"
							secondRowThreeTxt=""
							transparent
							secondary
							offsetY={calcOffset(100)}
							title={"Game Production"}
							track={"MOONCOURT BALLIN'"}
							duration={duration}
							isSmallScreen={props?.isSmallScreen}
						/>
					</div>
					<div
						className="complications-wrapper"
						style={{ visibility: "hidden", opacity: 0 }}
						id="comp-vid-1"
						ref={compRef01}
					>
						<CompHeaderImage
							nobg
							offsetY={calcOffset(-50)}
							isSmallScreen={props?.isSmallScreen}
						/>
						<CompCountdown
							transparent
							nobg
							title={"Time left"}
							duration={duration}
							timeoffset={22}
							offsetY={calcOffset(-110)}
							offsetX={calcOffset(0)}
							isSmallScreen={props?.isSmallScreen}
						/>
						<CompSpacer /> <CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompLeaderboard
							transparent
							title={"Leaderboard"}
							player-name-0={"D1rk"}
							player-name-1={"im-poser"}
							player-name-2={"styl3r"}
							player-score-0={502150}
							player-score-1={425400}
							player-score-2={385850}
							duration={duration}
							timeoffset={22}
							offsetX={calcOffset(-25)}
							align={"left"}
							isSmallScreen={props?.isSmallScreen}
						/>
					</div>
					<div
						className="complications-wrapper"
						style={{ visibility: "hidden", opacity: 0 }}
						id="comp-vid-2"
						ref={compRef02}
					></div>
				</>
			) : (
				<>
					<div
						className="complications-wrapper"
						style={{ visibility: "hidden", opacity: 0 }}
						id="comp-vid-0"
						ref={compRef00}
					>
						<CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompProgressTimeline
							firstRowOneTxt="Prototype"
							firstRowTwoTxt="Brand Integration"
							firstRowThreeTxt="Level Design"
							firstRowFourTxt="Balancing"
							firstRowFiveTxt="Publish"
							secondRowOneTxt=""
							secondRowTwoTxt="Sprint 2"
							secondRowThreeTxt=""
							transparent
							secondary
							title={"Game Production"}
							track={"MOONCOURT BALLIN'"}
							duration={duration}
							isSmallScreen={props?.isSmallScreen}
							offsetY={calcOffset(100)}
						/>
						<CompSpacer />
					</div>
					<div
						className="complications-wrapper"
						style={{ visibility: "hidden", opacity: 0 }}
						id="comp-vid-1"
						ref={compRef01}
					>
						<CompHeaderImage nobg />
						<CompSpacer /> <CompSpacer />
						<CompCountdown
							transparent
							title={"Time left"}
							duration={duration}
							timeoffset={22}
							offsetX={calcOffset(-150)}
							align={"right"}
							isSmallScreen={props?.isSmallScreen}
						/>
						<CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompSpacer />
						<CompLeaderboard
							transparent
							title={"Leaderboard"}
							player-name-0={"D1rk"}
							player-name-1={"im-poser"}
							player-name-2={"styl3r"}
							player-score-0={502150}
							player-score-1={425400}
							player-score-2={385850}
							duration={duration}
							timeoffset={22}
							offsetX={calcOffset(150)}
							align={"left"}
							isSmallScreen={props?.isSmallScreen}
						/>
						<CompSpacer />
						<CompSpacer />
					</div>
					<div
						className="complications-wrapper"
						style={{ visibility: "hidden", opacity: 0 }}
						id="comp-vid-2"
						ref={compRef02}
					></div>
				</>
			)}
		</>
	);
});
